export default __webpack_public_path__ + "static/media/rugr_white_logo.32d01409.svg";